import { ISettings } from "../../components/Sessings/Settings";

export const SETTINGS_SET_ACTION = 'SETTINGS_SET_ACTION';

export interface ISettingsSetAction {
    readonly type: typeof SETTINGS_SET_ACTION;
    readonly settings: ISettings;
}

export type TSettingsActions =
    ISettingsSetAction;

export const settingsSet = (settings: ISettings): ISettingsSetAction => ({ type: SETTINGS_SET_ACTION, settings });